import React from 'react';
import LazyLoad from 'react-lazyload';
import styled, { css } from 'styled-components';
import { Container } from '@nfs-react/components';
import { useImg, useText } from 'hooks';
import { DESKTOP, MOBILE, TABLET } from 'helpers/styles/media';
import {
  Button,
  ChangeableBackgroundSection,
  ChangeableButtonBg,
} from 'helpers/components';

const Content = () => {
  return (
    <ChangeableBackgroundSection
      id="content-background"
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <ContentContainer>
          <TextContainer>
            <Title>{useText('article__title', true)}</Title>
            <Text>{useText('article__content', true)}</Text>
          </TextContainer>
          <ImageContainer>
            <LazyLoad>{useImg('art-image.jpg', 'article-image')}</LazyLoad>
          </ImageContainer>
        </ContentContainer>
        <Container>
          <ChangeableButtonBg
            id="content-background-btn"
            defaultColor="yellow"
            buttonContainerCss={buttonContainerStyles}
          >
            <Button buttonCss={buttonStyles}>
              {useText('article__button', true)}
            </Button>
          </ChangeableButtonBg>
        </Container>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const ContentContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  position: relative;
  margin-bottom: 40px;

  @media ${MOBILE} {
    display: block;
  }
`;

const TextContainer = styled.div`
  position: relative;
  max-width: 650px;
`;

const Wrapper = styled.div`
  position: relative;
  padding-bottom: 70px;

  @media ${TABLET} {
    padding-bottom: 45px;
  }

  @media ${MOBILE} {
    padding-bottom: 35px;
  }
`;

const Title = styled.div`
  font-size: 25px;
  font-weight: 700;
  color: #333b56;
  padding: 30px 25px;
  position: relative;
  margin-bottom: 21px;
  &::before {
    content: '';
    border-left: 9px solid var(--primary-color-1);
    position: absolute;
    left: 0;
    height: 60px;
    top: 13px;

    @media ${TABLET} {
      border-left: 6px solid var(--primary-color-1);
      height: 42px;
      top: 19px;
    }
  }

  @media ${TABLET} {
    font-size: 17.5px;
    margin-bottom: 5px;
  }

  @media ${MOBILE} {
    padding: 10px 25px;
    font-size: 25px;
    line-height: 26px;
  }
`;

const Text = styled.div`
  p {
    max-width: 645px;
    font-size: 20px;
    line-height: 138.1%;
    margin-bottom: 30px;
    @media ${TABLET} {
      font-size: 15px;
      line-height: 20px;
      margin-bottom: 20px;
    }

    @media ${MOBILE} {
      font-size: 17px;
      line-height: 23px;
    }
  }
  @media ${TABLET} {
    max-width: 390px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  margin-top: 28px;

  @media ${TABLET} {
    max-width: 317px;
    margin-top: 90px;
  }
`;

const buttonContainerStyles = css`
  width: 100%;
`;

const buttonStyles = css`
  display: flex;
  border-radius: 35px;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-align: center;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
  padding: 5px 25px;
  cursor: pointer;
  box-shadow: 0px 4.51487px 10.1585px rgba(0, 0, 0, 0.18);
  margin: auto;
  width: 100%;

  @media ${DESKTOP} {
    min-height: 70px;
    font-size: 24px;
    line-height: 28px;
    max-width: 800px;
    &:hover {
      transform: scale(1.08);
    }
  }

  @media ${TABLET} {
    font-size: 16px;
    line-height: 22px;
    max-width: 550px;
    min-height: 46px;
    &:active {
      transform: scale(1.08);
    }
  }

  @media ${MOBILE} {
    font-size: 18px;
    line-height: 22px;
    min-height: 70px;
    max-width: 340px;
    &:active {
      transform: scale(1.08);
    }
  }
`;

export default Content;
